module.exports = __webpack_public_path__ + "img/hm_block03_02_tc.ac8cf9b0.png";